import { Scaling } from "./Scaling";
import { IReel } from "neo-games/Engine/Communication/Game/Types/IReel";
import { Symbol } from "../GameComponents/Symbol";
import { Symbols } from "../GameComponents/Symbols";
import { GameManager } from "../Managers/GameManager";

/**
 * @class CustomUtils
 * @author Marek Turkovic
 * 25.10.2019
 * todo Implement not only on baseResponse, but freespinsRespons etc..
 */
export class CustomUtils {
    public static getBlendMode(blendMode: number): number {
        if (Scaling.IsIOs) {
            if (blendMode == 1) {
                blendMode = 3;
            }
        }

        return blendMode;
    }

    public static updateSpineData(spineData: JSON): JSON {
        if (Scaling.IsIOs) {
            if (spineData != null) {
                let spineTextData = JSON.stringify(spineData);
                spineTextData = spineTextData.split('"blend":"additive"').join('"blend":"screen"');
                spineData = JSON.parse(spineTextData);
            }
        }

        return spineData;
    }

    public static getCurrentSymbolsCases(currentSymbols: Array<Array<Symbol>>): Array<Array<string>> {
        let symbolsCases: Array<Array<string>> = [];

        for (let i: number = 0; i < currentSymbols.length; i++) {
            symbolsCases.push([]);

            for (let j: number = 0; j < currentSymbols[i].length; j++) {
                symbolsCases[i].push(currentSymbols[i][j].getCurrentCase());
            }
        }

        return symbolsCases;
    }

    /**
     * Indicates that respin was triggered.
     * @returns {boolean}
     */
    static isRespinEnabled(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId === 0
        );
    }

    /**
     * Indicates that respin is in progress.
     * @returns {boolean}
     */
    static isRespinActive(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId > 0
        );
    }
    /*
    public static getReelsInitDataWithTopReel(reelsData: Array<Array<number>>, reelTopData: Array<number>): Array<Array<number>> {
        var copiedReelsData: Array<Array<number>> = <Array<Array<number>>>(JSON.parse(JSON.stringify(reelsData)));
        var copiedReelTopData: Array<number> = <Array<number>>(JSON.parse(JSON.stringify(reelTopData)));

        copiedReelsData.unshift(copiedReelTopData);

        return copiedReelsData;
    }

    public static getStoppedSymbolsArrayWithTopReel(reelData: Array<IReel>, reelTopData: IReel, reelsHorizontalMask: Array<number>): Array<IReel> {
        var copiedReelData: Array<IReel> = <Array<IReel>>(JSON.parse(JSON.stringify(reelData)));
        var copiedReelTopData: IReel = <IReel>(JSON.parse(JSON.stringify(reelTopData)));

        for(let i: number = 0; i < copiedReelData.length; i++) {
            // remove top reel symbols included in data
            if(copiedReelData.length == reelsHorizontalMask.length) {
                if(reelsHorizontalMask[i] > 0) {
                    if(copiedReelData[i].symbols) {
                        copiedReelData[i].symbols.shift();
                    }

                    if(copiedReelData[i].transform) {
                        copiedReelData[i].transform.shift();
                    }
                }
            }
        }

        copiedReelData.unshift(copiedReelTopData);

        return copiedReelData;
    }

    public static convertCurrentSymbolsCasesWithTopReel(currentSymbols: Array<Array<Symbol>>, reelsHorizontalMask: Array<number>): Array<Array<string>> {
        let symbolsCases: Array<Array<string>> = [];
        let topSymbolsCases: Array<string> = [];

        if(currentSymbols.length == reelsHorizontalMask.length) {
            for(let i: number = 0; i < currentSymbols.length; i++) {
                symbolsCases.push([]);

                for (let j: number = 0; j < currentSymbols[i].length; j++) {
                    if (reelsHorizontalMask[i] > 0 && j == 0) {
                        topSymbolsCases.push(currentSymbols[i][j].getCurrentCase());
                    } else {
                        symbolsCases[i].push(currentSymbols[i][j].getCurrentCase());
                    }
                }
            }
            symbolsCases.unshift(topSymbolsCases);
        }

        return symbolsCases;
    }
*/

    /*
    public static convertBaseResponseData(baseResponse: Communication.Game.GameModuleBaseResponse): void {
        if(Settings.ReelsCount != undefined && Settings.ReelsCount > 0) {
            if(baseResponse.initData != null
                && baseResponse.initData.reels.length < Settings.ReelsCount && baseResponse.initData.reels.length > 4
                && baseResponse.initData.customData != null && baseResponse.initData.customData["topReel"])
            {
                baseResponse.initData.reels.unshift(baseResponse.initData.customData["topReel"]); // symbols baseResponse for top reel rotation
            }

            if(baseResponse.screen.reels.length < Settings.ReelsCount && baseResponse.screen.reels.length > 4) {
                let symbols: Array<number> = [];
                let transform: Array<number> = [];

                // baseResponse for top reel, remove from reel 1-4
                // *       1 2 3 4     - top reel on index 1-4
                // *     2 3 4 5 6 7
                // *     2 3 4 5 6 7/
                // *     2 3 4 5 6 7
                // *     2 3 4 5 6 7

                for (let i: number = 1; i <= 4; i++) {
                    symbols.unshift(baseResponse.screen.reels[i].symbols.shift());
                    transform.unshift(baseResponse.screen.reels[i].transform.shift());
                }

                baseResponse.screen.reels.unshift(Object()); // add new reel on index 0

                // set baseResponse to new reel
                baseResponse.screen.reels[0].index = baseResponse.customData["topReel"].index;
                baseResponse.screen.reels[0].symbols = symbols;
                baseResponse.screen.reels[0].transform = transform;
                // baseResponse.screen.reels[0].overlay = [];
                // baseResponse.screen.reels[0].mask = [];
                // baseResponse.screen.reels[0].customData = [];
            }
        }
    }
*/
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/CustomUtils.ts
 **/